import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  user: null,
  response: null,
  loading: false,
  error: null,
  callTimes: 0,
  message: '',
  data: []
}

export const categorySlice = createSlice({
  name: 'categorySliceName',
  initialState,
  reducers: {
    addCategory: (state) => {
      state.loading = true;
    },
    getCategory: (state) => {
      state.loading = true;
    },
    getOneCategory: (state) => {
      state.loading = true;
    },

    successCategory: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    },
    removeCategory: (state) => {
      state.loading = true;
    },
    updateCategory: (state) => {
      state.loading = true;
    },
    emptyCart: (state, action) => {
      state.value += action.payload
    },
    searchCategoryByName: (state) => {
      state.loading = true;
    },
    failedCategory: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    }
  },
})

// Action creators are generated for each case reducer function
export const { addCategory, removeCategory, updateCategory, getCategory, successCategory, getOneCategory, searchCategoryByName, failedCategory } = categorySlice.actions

export default categorySlice.reducer